export const turkishToLower = (str) => {
    if (typeof str !== 'string') {
        return '';
    }
    return str.replace(/İ/g, 'i')
    .replace(/I/g, 'ı')
    .replace(/Ğ/g, 'ğ')
    .replace(/Ü/g, 'ü')
    .replace(/Ş/g, 'ş')
    .replace(/Ö/g, 'ö')
    .replace(/Ç/g, 'ç')
    .toLowerCase();
};

/**
 * Hakim adını kaydetmeden önce normalize eder:
 * - baş/son boşlukları siler
 * - ardışık birden fazla boşluğu tek boşluğa indirger
 * - Türkçe büyük harfe çevirir (i → İ, ı → I doğru şekilde)
 * Manuel/eski hakim eşleştirmesini tutarlı tutmak için tüm hakim adları
 * bu fonksiyondan geçirilmelidir.
 */
export const normalizeJudgeName = (name) => {
    if (typeof name !== 'string') return '';
    return name.trim().replace(/\s+/g, ' ').toLocaleUpperCase('tr-TR');
};
